import React from 'react';
import PropTypes from 'prop-types';
// import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Table } from '../index';
import { formatarCnpj } from '../../utils/helpers';

const ListaAbrangencia = (props) => {
  const options = {
    noDataText: 'Nenhuma orgão vinculado ao ente federativo',
    hideSizePerPage: true,
    sizePerPage: 10,
  };

  const tableHeader = [{
    id: 'cnpj',
    label: 'CNPJ',
  }, {
    id: 'nomeOrgaoVinculado',
    label: 'Orgão',
    dataAlign: 'justify',
    width: '60%',
    style: 'text-align: center',
  }];

  const listaFormatada = props.listaAbrangenciaRPPS.map((item) => {
    const itemIndexado = item;
    if (itemIndexado.cnpj) {
      itemIndexado.cnpj = formatarCnpj(itemIndexado.cnpj);
    }
    return itemIndexado;
  });

  return props.listaAbrangenciaRPPS.length > 0 ? (
    <Table
      bordered
      data={listaFormatada}
      options={options}
      listaTableHeader={tableHeader}
      pagination
      scrollTop="Top"
    />
  ) : null;
};

ListaAbrangencia.propTypes = {
  listaAbrangenciaRPPS: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    idParticipante: PropTypes.string,
    nomeOrgaoVinculado: PropTypes.string,
  })).isRequired,
};

export default ListaAbrangencia;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/ListaAbrangenciaRPPS.jsx